"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Rankine = /** @class */ (function () {
    function Rankine() {
    }
    Rankine.toCelcius = function (rankine) {
        if (rankine === void 0) { rankine = 1; }
        return rankine / 1.8 + 273.15;
    };
    Rankine.toFahrenheit = function (rankine) {
        if (rankine === void 0) { rankine = 1; }
        return rankine - 459.67;
    };
    Rankine.toKelvin = function (rankine) {
        if (rankine === void 0) { rankine = 1; }
        return rankine / 1.8;
    };
    Rankine.toReamur = function (rankine) {
        if (rankine === void 0) { rankine = 1; }
        return (rankine / 1.8 + 273.15) * 0.8;
    };
    Rankine.toNewton = function (rankine) {
        if (rankine === void 0) { rankine = 1; }
        return (rankine - 491.67) * 11 / 60;
    };
    Rankine.toDelisle = function (rankine) {
        if (rankine === void 0) { rankine = 1; }
        return (671.67 - rankine) * 5 / 6;
    };
    Rankine.toRomer = function (rankine) {
        if (rankine === void 0) { rankine = 1; }
        return (rankine - 491.67) * 7 / 24 + 7.5;
    };
    Rankine.unit = {
        name: 'Rankine',
        code: '°Ra'
    };
    return Rankine;
}());
exports.Rankine = Rankine;
